// src/components/store/QuickAddressComponents/UserInfoSection.jsx
import React from "react";
import { Button } from "@radix-ui/themes";
import { LogIn } from "lucide-react";
import { useSalesContext } from "../../../contexts/SalesContext";
import { handlePhoneChange } from "../../../scripts/generalScript";

export const UserInfoSection = ({ setAccessModalOpen }) => {
  const { name, setName, phone, setPhone, email, setEmail } = useSalesContext();

  return (
    <div className="bg-white rounded-xl p-4 mb-4">
      <h3 className="text-lg font-medium mb-4">Información personal</h3>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Nombre completo
          </label>
          <input
            type="text"
            className="w-full p-2 border rounded focus:ring-blue-500 focus:border-blue-500"
            placeholder="Tu nombre y apellido"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Teléfono / WhatsApp
          </label>
          <input
            type="tel"
            className="w-full p-2 border rounded focus:ring-blue-500 focus:border-blue-500"
            placeholder="+57 300 123 4567"
            value={phone}
            onChange={(e) => {
              const formattedPhone = handlePhoneChange(e);
              setPhone(formattedPhone);
            }}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Correo electrónico
          </label>
          <input
            type="email"
            className="w-full p-2 border rounded focus:ring-blue-500 focus:border-blue-500"
            placeholder="tucorreo@ejemplo.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
      </div>
      <div className="mt-6">
        <Button
          className="w-full bg-blue-600 hover:bg-blue-700 text-white"
          onClick={() => setAccessModalOpen(true)}
        >
          <LogIn className="mr-2 h-4 w-4" />
          Iniciar sesión o registrarse
        </Button>
        <p className="text-sm text-gray-500 mt-2 text-center">
          Crea una cuenta para gestionar tus pedidos y direcciones
        </p>
      </div>
    </div>
  );
};

export default UserInfoSection;